import { MultiProductBlockCardItem } from './types';
import { ComponentMultiProductBlock } from '$/(cms)/_modules/cmsService/types';

export const buildCardItems = (
  products: ComponentMultiProductBlock['products'],
): MultiProductBlockCardItem[] => {
  return (products ?? []).reduce<MultiProductBlockCardItem[]>((acc, item) => {
    if (!item?.product || acc.length >= 3) {
      return acc;
    }

    acc.push({
      id: item.id ?? '',
      product: item.product,
      override_badge: item.override_badge,
    });

    return acc;
  }, []);
};

export const getCardKey = (
  item: MultiProductBlockCardItem,
  index: number,
): string => {
  return `${item.product.uid ?? item.id ?? item.product.title ?? index}`;
};
